import { useState } from 'react'
import { Coffee } from 'lucide-react'
import { BottomSheet } from '@/shared/ui/bottom-sheet'
import { useTelegram } from '@/shared/lib/telegram'
import { TeaSearchContent, type SelectedTea } from '@/widgets/tea-search-content'
import { QuickAddSheet } from '@/widgets/quick-add-sheet'
import { cn } from '@/shared/lib/utils'

/**
 * Главный CTA-блок "Хочу записать чай"
 * 
 * Открывает bottom sheet с TeaSearchContent для выбора чая,
 * затем QuickAddSheet для быстрого добавления записи.
 */
export function HomeCTA() {
  const { hapticFeedback } = useTelegram()
  const [isSelectOpen, setIsSelectOpen] = useState(false)
  const [selectedTea, setSelectedTea] = useState<SelectedTea | null>(null)
  const [isQuickAddOpen, setIsQuickAddOpen] = useState(false)
  
  const handleCTAClick = () => {
    hapticFeedback.impactOccurred('medium')
    setIsSelectOpen(true)
  }
  
  const handleTeaSelect = (tea: SelectedTea) => {
    setSelectedTea(tea)
    setIsSelectOpen(false)
    setTimeout(() => setIsQuickAddOpen(true), 200)
  }
  
  const handleQuickAddClose = () => {
    setIsQuickAddOpen(false)
    setSelectedTea(null)
  }

  const handleSheetClose = () => {
    setIsSelectOpen(false)
  }
  
  return (
    <>
      <button
        onClick={handleCTAClick}
        className={cn(
          'widget-card !p-0 overflow-hidden w-full',
          'active:scale-[0.99] transition-transform duration-100'
        )}
      >
        <div className="relative bg-gradient-to-r from-primary-light to-primary-dark text-white px-5 py-4 sm:px-6 sm:py-5 shadow-lg dark:from-primary-dark dark:to-primary-darker min-h-[72px] sm:min-h-[80px]">
          <div className="relative flex items-center gap-4">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0 border border-white/30">
              <Coffee className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={2} />
            </div>
            <div className="flex-1 text-left">
              <h2 className="text-lg sm:text-xl font-bold leading-tight">Хочу записать чай</h2>
              <p className="text-xs sm:text-sm text-white/85 leading-tight mt-0.5">
                Добавьте впечатление — это займёт меньше минуты
              </p>
            </div>
          </div>
        </div>
      </button>
      
      {/* BottomSheet выбора чая */}
      <BottomSheet
        isOpen={isSelectOpen}
        onClose={handleSheetClose}
        title="Выберите чай"
        height={90}
      >
        <div className="px-4 pt-2 pb-6">
          <TeaSearchContent 
            onSelect={handleTeaSelect}
            variant="sheet"
          />
        </div>
      </BottomSheet>
      
      {/* QuickAddSheet для записи */}
      <QuickAddSheet
        isOpen={isQuickAddOpen}
        onClose={handleQuickAddClose}
        teaId={selectedTea?.id}
        teaName={selectedTea?.name}
        teaCategory={selectedTea?.category}
        photoUrl={selectedTea?.imageUrl}
        onSuccess={handleQuickAddClose}
      />
    </>
  )
}
